import * as React from 'react';
import './_CardAttachmentDropPanel.scss';
import { ICardAttachmentDropPanelElementProps, ICardAttachmentDropPanelProps } from './types';
import { CLASS_CARD_DETAILS, CLASS_CARD_DETAILS_SECTION } from '../../../constants';
import { CLASS_ASIDE_DROP_PORTAL, CLASS_ASIDE_PANEL } from '../../../../asidePanel/constants';
import { getParentsClasses } from '../../../../../helpers/getParentsClasses';
import {
    ACTIVE_SECTION_TIMER,
    CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT, CLASS_ASIDE_PANEL_PORTAL_HIDE, ID_ASIDE_PANEL_PORTAL
} from '../../../../asidePanel/components/AsidePanelActionsButton/constants';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { TonUpload } from '../../types';
import {
    CARD_ATTACHMENTS_DROP_PANEL_DRAG,
    CARD_ATTACHMENTS_DROP_PANEL_DRAG_ATTACHMENTS,
    CARD_ATTACHMENTS_DROP_PANEL_DRAG_COMMENTS,
    CARD_ATTACHMENTS_DROP_PANEL_UPLOAD
} from './constants';
import { CLASS_COMMENTS_INPUT } from '../../../../../base/components/Comments/components/CommentsInput/constants';
import { Icon } from 'kui';
import { CARD_CLASS } from '../../../../../main/kanbanView';

export function CardAttachmentDropPanel ({
    onDropFiles,
    onPasteFile,
    onPasteFileAsComment
}: ICardAttachmentDropPanelProps) {
    const [progress, setProgress] = React.useState(null);
    const [s] = React.useState<any>({});
    s.progress = progress; // для addEventListener onDragEnd

    const { openedProperty: openedPropertyContext, setOpenedProperty: setOpenedPropertyContext, cardId, isMobile, isCommentsColumn, showedProperties, addShowedProperty } = React.useContext(AsidePanelContext);
    const [openedProperty, setOpenedProperty] = React.useState(openedPropertyContext);
    s.openedProperty = openedProperty; // геттер для openedPropertyContext для onDropFiles
    React.useEffect(() => {
        setOpenedProperty(openedPropertyContext);
    }, [openedPropertyContext]);

    const highlightTimer = React.useRef(null);

    const className = CLASS_CARD_DETAILS + '-attachment__droppable';
    const classContainer = className + '-container';
    const classNameDragging = CLASS_ASIDE_DROP_PORTAL + '--dragging';
    const classNameProgress = CLASS_CARD_DETAILS + '-attachment__droppable-progress';
    const classNameHint = CLASS_CARD_DETAILS + '-attachment__droppable-hint';
    const classAttachmentSectionId = CLASS_CARD_DETAILS_SECTION + `-attachments--${cardId}`;

    const onProgress = (percent: number) => {
        setProgress(Math.round(percent));
    }
    const onFinish = (asComment: boolean = false) => {
        const container = getContainer();
        if (container) container.classList.remove(classNameDragging);
        setProgress(null);

        if (asComment) {
            if (!showedProperties.has(EAsidePanelProperty.CARD_COMMENTS)) {
                addShowedProperty(EAsidePanelProperty.CARD_COMMENTS, isCommentsColumn);
            }
            const activeElement = document.activeElement as HTMLElement;
            if (activeElement) activeElement.blur();
        } else {
            if (!showedProperties.has(EAsidePanelProperty.CARD_ATTACHMENTS)) {
                addShowedProperty(EAsidePanelProperty.CARD_ATTACHMENTS, isCommentsColumn);
            }
            // scrollToSection from AsidePanelActionsButton
            const selector = `.${CLASS_CARD_DETAILS_SECTION}--attachments.${classAttachmentSectionId}`;
            const section = document.querySelector(selector) as HTMLElement;
            if (!section) return;
                const highlighted = document.querySelector('.' + CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT);
                if (highlighted) highlighted.classList.remove(CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT); // если ещё предыдущая секция подсвечивается
                section.classList.add(CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT); // подсветить секцию
                section.scrollIntoView();

                if (highlightTimer.current) clearTimeout(highlightTimer.current);
                highlightTimer.current = setTimeout(() => {
                    section.classList.remove(CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT); // убрать подсветку
                }, ACTIVE_SECTION_TIMER * 2);
            }
        const isPopup = s.openedProperty === EAsidePanelProperty.CARD_ATTACHMENTS;
        if (isPopup) setOpenedPropertyContext(null, isMobile, isCommentsColumn);
    }

    const getContainer = () => {
        return document.querySelector('.' + CLASS_ASIDE_DROP_PORTAL) as HTMLElement;
    }

    React.useEffect(() => {
        const onPaste = (event: any) => {
            if (
                !event.clipboardData ||
                !event.clipboardData.items ||
                !event.clipboardData.items.length
            ) return;

            const items = event.clipboardData.items;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type) {
                    const file = items[i].getAsFile();
                    if (file) {
                        event.preventDefault();
                        const container = getContainer();
                        if (container) container.classList.add(classNameDragging);
                        setProgress(0);
                        const activeDocument = document.activeElement;
                        const commentInput = document.querySelector(`.${CLASS_ASIDE_PANEL} .${CLASS_COMMENTS_INPUT} textarea`) ||
                            document.querySelector(`.${CLASS_ASIDE_PANEL} .${CLASS_COMMENTS_INPUT} .ql-clipboard`);
                        const asComment = activeDocument === commentInput;
                        const onPasteFunc: TonUpload = asComment ? onPasteFileAsComment : onPasteFile;
                        return onPasteFunc([file], onProgress)
                            .finally(() => onFinish(asComment));
                    }
                }
            }
        }
        document.addEventListener('paste', onPaste);

        return () => {
            document.removeEventListener('paste', onPaste);
            if (highlightTimer.current) clearTimeout(highlightTimer.current);
        }
    }, []);

    return (
        <div
            className={`
                ${classContainer}
                ${isCommentsColumn ? classContainer + '--columns' : ''}
            `}
        >
            {progress === null ?
                <>
                    <CardAttachmentDropPanelElement
                        className={className + '--attachments'}
                        dragText={CARD_ATTACHMENTS_DROP_PANEL_DRAG_ATTACHMENTS}
                        icon={'e-board'}
                        openedProperty={s.openedProperty}
                        progress={s.progress}
                        getContainer={getContainer}
                        onDropFiles={onDropFiles}
                        onFinish={onFinish}
                        onProgress={onProgress}
                        setProgress={setProgress}
                    />
                    <CardAttachmentDropPanelElement
                        className={className + '--comments'}
                        dragText={CARD_ATTACHMENTS_DROP_PANEL_DRAG_COMMENTS}
                        icon={'e-comments'}
                        openedProperty={s.openedProperty}
                        progress={s.progress}
                        getContainer={getContainer}
                        onDropFiles={(files, isPopup, onProgress) => onDropFiles(files, isPopup, onProgress, true)}
                        onFinish={() => onFinish(true)}
                        onProgress={onProgress}
                        setProgress={setProgress}
                    />
                </>
                : <div className={classNameProgress + '-container'}>
                    {
                        progress
                            ? <div className={classNameProgress}>
                                {progress} %
                            </div>
                            : <div className={classNameHint}>
                                {CARD_ATTACHMENTS_DROP_PANEL_UPLOAD}
                            </div>
                    }
                </div>
            }
        </div>
    )
}

function CardAttachmentDropPanelElement ({
    className: classNameOwn,
    dragText,
    icon,
    openedProperty,
    progress,
    getContainer,
    onDropFiles,
    onFinish,
    onProgress,
    setProgress,
}: ICardAttachmentDropPanelElementProps) {
    const [isDroppable, setDroppable] = React.useState(false);

    const className = CLASS_CARD_DETAILS + '-attachment__droppable';
    const classNameDragging = CLASS_ASIDE_DROP_PORTAL + '--dragging';
    const classNameDroppable = isDroppable ? className + '--droppable' : '';
    const classNameHint = CLASS_CARD_DETAILS + '-attachment__droppable-hint';

    const onDragOver = (event: any) => {
        event.preventDefault();
        setDroppable(true);
    }
    const onDragLeave = (event: any) => {
        if (progress !== null) return;

        const targetClasses = getParentsClasses(
            event.relatedTarget as HTMLElement,
            [classNameOwn]
        );
        if (targetClasses.includes(classNameOwn)) return;

        setDroppable(false);
    }
    const onDrop = (event: any) => {
        event.preventDefault();
        if (progress !== null) return;

        const newCardContainer = document.querySelector(`.${CARD_CLASS}-attachment-drop`) as HTMLElement;
        if (newCardContainer) newCardContainer.classList.remove(`${CARD_CLASS}-attachment-drop--dragging`);

        const files = event.dataTransfer.files;
        if (files && files.length) {
            setProgress(0);
            const isPopup = openedProperty === EAsidePanelProperty.CARD_ATTACHMENTS;
            onDropFiles(files, isPopup, onProgress)
                .finally(() => {
                    setDroppable(false);
                    onFinish();
                });
        }
    }

    React.useEffect(() => {
        const onDrag = (event: any) => {
            if (
                !event ||
                !event.dataTransfer ||
                !event.dataTransfer.types ||
                !event.dataTransfer.types.length ||
                !event.dataTransfer.types.includes('Files')
            ) return;

            const asidePortal = document.querySelector(`#${ID_ASIDE_PANEL_PORTAL}`) as HTMLElement;
            if (asidePortal) {
                asidePortal.classList.add(CLASS_ASIDE_PANEL_PORTAL_HIDE);
            }
            const container = getContainer();
            if (container) container.classList.add(classNameDragging);
        }
        const onDragEnd = (event: any) => {
            if (progress !== null) return;

            const targetClasses = getParentsClasses(
                event.relatedTarget as HTMLElement,
                ['page']
            );
            if (targetClasses.includes('page')) return;

            const asidePortal = document.querySelector(`#${ID_ASIDE_PANEL_PORTAL}`) as HTMLElement;
            if (asidePortal) {
                asidePortal.classList.remove(CLASS_ASIDE_PANEL_PORTAL_HIDE);
            }

            const container = getContainer();
            if (container) container.classList.remove(classNameDragging);
            setDroppable(false);
        }

        document.addEventListener('dragover', onDrag);
        document.addEventListener('dragleave', onDragEnd);
        document.addEventListener('dragend', onDragEnd);

        return () => {
            document.removeEventListener('dragover', onDrag);
            document.removeEventListener('dragleave', onDragEnd);
            document.removeEventListener('dragend', onDragEnd);
        }
    }, []);

    return (
        <div
            className={`
                ${className}
                ${classNameOwn}
                ${classNameDroppable}
            `}
            onDragEnter={onDragOver}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
        >
            <div className={classNameHint}>
                <Icon xlink={icon} className={classNameHint + '-icon'} size={96} />
                <span className={classNameHint + '-title'}>{CARD_ATTACHMENTS_DROP_PANEL_DRAG}</span>
                <span className={classNameHint + '-subtitle'}>{dragText}</span>
            </div>
        </div>
    )
}
